const tokens = {
  "space": {
    "0": "0",
    "100": "1rem",
    "150": "1.5rem",
    "200": "2rem",
    "300": "3rem",
    "400": "4rem",
    "012": "0.125rem",
    "025": "0.25rem",
    "050": "0.5rem"
  },
  "color": {
    "text": {
      "default": "#092340",
      "headline": "#092340",
      "subdued": "#575757",
      "onDark": "#ffffff",
      "disabled": "#C2C2C2",
      "success": "#2B8028",
      "danger": "#D91208",
      "button": {
        "default": "#ffffff",
        "secondary": "#007DB7"
      },
      "alert": {
        "default": "#092340",
        "secondary": "#ffffff"
      },
      "link": {
        "default": "#007DB7",
        "hover": "#006695",
        "subdued": "#092340",
        "onDark": "#089ADE"
      },
      "badge": {
        "default": "#092340"
      },
      "headerNav": {
        "menu": "#ffffff",
        "button": "#ffffff"
      },
      "footerNav": {
        "bar": "#ffffff"
      }
    },
    "background": {
      "default": "#ffffff",
      "secondary": "#F4F4F4",
      "dark": "#092340",
      "disabled": "#EDEDED",
      "accent": "#FFC72C",
      "input": {
        "default": "#FAFAFA",
        "secondary": "#ffffff",
        "hover": "#EDEDED",
        "pressed": "#EDEDED",
        "onDark": "#092340",
        "hoverOnDark": "#383838"
      },
      "action": {
        "default": "#575757",
        "hover": "rgba(87, 87, 87, 0.08)",
        "selected": "#007DB7",
        "onDark": "#ffffff",
        "hoverOnDark": "rgba(255, 255, 255, 0.08)",
        "secondary": {
          "default": "#252525",
          "hover": "rgba(37, 37, 37, 0.08)",
          "pressed": "rgba(37, 37, 37, 0.36)"
        }
      },
      "button": {
        "default": "#007DB7",
        "hover": "#006695",
        "pressed": "#006695",
        "secondary": {
          "default": "#ffffff",
          "hover": "#EDEDED"
        }
      },
      "alert": {
        "default": "#FFC72C",
        "secondary": "#007DB7"
      },
      "success": {
        "default": "#2B8028",
        "subdued": "#EDF8ED"
      },
      "danger": {
        "default": "#EA1609",
        "subdued": "#FBEDEA",
        "pressed": "#D91208"
      },
      "warning": {
        "default": "#FED647",
        "subdued": "#FFF2C5"
      },
      "badge": {
        "default": "#FFC72C"
      },
      "subdued": {
        "default": "#d9d9d9",
        "onDark": "#8C8C8C"
      },
      "toggle": {
        "selected": "#007DB7",
        "inactive": "#8C8C8C"
      },
      "headerNav": {
        "bar": "#092340",
        "menu": "#006695",
        "cartAnimation": "rgb(100% 78% 17.3% / 0.2)",
        "button": {
          "default": "#007DB7",
          "hover": "#006695"
        }
      },
      "footerNav": {
        "bar": "#191919"
      }
    },
    "icon": {
      "default": "#092340",
      "subdued": "#757575",
      "onDark": "#ffffff",
      "disabled": "#C2C2C2",
      "success": "#2B8028",
      "warning": "#FED647",
      "danger": "#D91208",
      "link": {
        "default": "#007DB7",
        "hover": "#006695"
      },
      "button": {
        "default": "#ffffff",
        "secondary": "#007DB7"
      },
      "trails": {
        "easy": "#3AAA36",
        "intermediate": "#3772C4",
        "expert": "#000000",
        "terrain": "#F68C42",
        "fun": "#7C3EB3"
      },
      "action": {
        "default": "#575757",
        "onDark": "#ffffff",
        "selected": "#007DB7"
      },
      "headerNav": {
        "bar": "#092340",
        "menu": "#ffffff",
        "button": "#ffffff"
      }
    },
    "border": {
      "default": "#d9d9d9",
      "onDark": "#ffffff",
      "dark": "#092340",
      "disabled": "#EDEDED",
      "success": "#2B8028",
      "danger": "#EA1609",
      "warning": "#FFC72C",
      "button": {
        "secondary": "#007DB7"
      },
      "focused": {
        "default": "#007DB7",
        "onDark": "#089ADE"
      },
      "input": {
        "default": "#757575",
        "focused": "#007DB7"
      },
      "link": {
        "default": "#E6B328",
        "hover": "#000000",
        "onDark": "#ffffff"
      }
    },
    "overlay": {
      "default": "rgba(0, 0, 0, 0.50)",
      "dark": "rgba(0, 0, 0, 0.80)"
    }
  },
  "font": {
    "letterSpacing": {
      "tight": "-0.025em",
      "default": "0em",
      "wide": "0.025em"
    },
    "display": {
      "weight": 700,
      "letterSpacing": "0em",
      "desktop": {
        "oversized": {
          "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
          "fontWeight": 700,
          "lineHeight": 1.1,
          "fontSize": "8rem",
          "letterSpacing": "0em",
          "textTransform": "uppercase"
        },
        "default": {
          "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
          "fontWeight": 700,
          "lineHeight": 1.1,
          "fontSize": "5.5rem",
          "letterSpacing": "0em",
          "textTransform": "uppercase"
        }
      },
      "tablet": {
        "default": {
          "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
          "fontWeight": 700,
          "lineHeight": 1.1,
          "fontSize": "3rem",
          "letterSpacing": "0em",
          "textTransform": "uppercase"
        }
      },
      "mobile": {
        "default": {
          "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
          "fontWeight": 700,
          "lineHeight": 1.1,
          "fontSize": "2.5rem",
          "letterSpacing": "0em",
          "textTransform": "uppercase"
        }
      },
      "textTransform": "uppercase"
    },
    "headline": {
      "mobile": {
        "01default": {
          "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
          "fontWeight": 700,
          "lineHeight": 1.2,
          "fontSize": "2.5rem",
          "letterSpacing": "0em",
          "textTransform": "uppercase"
        },
        "02": {
          "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
          "fontWeight": 700,
          "lineHeight": 1.2,
          "fontSize": "2rem",
          "letterSpacing": "0em",
          "textTransform": "uppercase"
        },
        "03": {
          "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
          "fontWeight": 700,
          "lineHeight": 1.2,
          "fontSize": "1.75rem",
          "letterSpacing": "0em",
          "textTransform": "uppercase"
        }
      },
      "04": {
        "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
        "fontWeight": 700,
        "lineHeight": 1.2,
        "fontSize": "1.5rem",
        "letterSpacing": "0em",
        "textTransform": "uppercase"
      },
      "05": {
        "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
        "fontWeight": 700,
        "lineHeight": 1.2,
        "fontSize": "1.25rem",
        "letterSpacing": "0em",
        "textTransform": "uppercase"
      },
      "weight": 700,
      "letterSpacing": "0em",
      "desktop": {
        "01default": {
          "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
          "fontWeight": 700,
          "lineHeight": 1.2,
          "fontSize": "4rem",
          "letterSpacing": "0em",
          "textTransform": "uppercase"
        },
        "02": {
          "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
          "fontWeight": 700,
          "lineHeight": 1.2,
          "fontSize": "2.5rem",
          "letterSpacing": "0em",
          "textTransform": "uppercase"
        },
        "03": {
          "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
          "fontWeight": 700,
          "lineHeight": 1.2,
          "fontSize": "2rem",
          "letterSpacing": "0em",
          "textTransform": "uppercase"
        }
      },
      "textTransform": "uppercase"
    },
    "title": {
      "default": {
        "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
        "fontWeight": 700,
        "lineHeight": 1.2,
        "fontSize": "1.25rem",
        "letterSpacing": "0.025em",
        "textTransform": "uppercase"
      },
      "subdued": {
        "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
        "fontWeight": 700,
        "lineHeight": 1.2,
        "fontSize": "1rem",
        "letterSpacing": "0.025em",
        "textTransform": "uppercase"
      }
    },
    "body": {
      "oversized": {
        "fontFamily": "Futura PT, futura-pt, sans-serif",
        "fontWeight": 600,
        "fontSize": "1.25rem",
        "lineHeight": 1.2,
        "letterSpacing": "0em"
      },
      "oversizedLink": {
        "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
        "fontWeight": 700,
        "fontSize": "1.25rem",
        "lineHeight": 1.2,
        "letterSpacing": "0em",
        "textDecoration": "underline"
      },
      "default": {
        "fontFamily": "Futura PT, futura-pt, sans-serif",
        "fontWeight": 400,
        "lineHeight": 1.5,
        "fontSize": "1rem"
      },
      "bold": {
        "fontFamily": "Futura PT, futura-pt, sans-serif",
        "fontWeight": 600,
        "lineHeight": 1.2,
        "fontSize": "1rem"
      },
      "subdued": {
        "fontFamily": "Futura PT, futura-pt, sans-serif",
        "fontWeight": 400,
        "lineHeight": 1.2,
        "fontSize": "0.875rem"
      },
      "link": {
        "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
        "fontWeight": 700,
        "lineHeight": 1.5,
        "fontSize": "1rem",
        "textDecoration": "underline"
      },
      "subduedLink": {
        "fontFamily": "Futura PT, futura-pt, sans-serif",
        "fontWeight": 400,
        "fontSize": "0.875rem",
        "lineHeight": 1.2
      },
      "button": {
        "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
        "fontWeight": 700,
        "lineHeight": "normal",
        "letterSpacing": "0em",
        "fontSize": "1rem",
        "textTransform": "uppercase"
      },
      "underlined": {
        "fontFamily": "Futura PT, futura-pt, sans-serif",
        "fontWeight": 400,
        "lineHeight": 1.5,
        "fontSize": "1rem",
        "textDecoration": "underline"
      },
      "compact": {
        "fontFamily": "Futura PT, futura-pt, sans-serif",
        "fontWeight": 400,
        "lineHeight": 1.2,
        "fontSize": "1rem"
      },
      "compactBold": {
        "fontFamily": "Futura PT, futura-pt, sans-serif",
        "fontWeight": 600,
        "lineHeight": 1.2,
        "fontSize": "1rem"
      },
      "compactLink": {
        "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
        "fontWeight": 700,
        "lineHeight": 1.2,
        "fontSize": "1rem",
        "textDecoration": "underline"
      }
    },
    "utility": {
      "default": {
        "fontFamily": "Futura PT, futura-pt, sans-serif",
        "fontWeight": 400,
        "fontSize": "0.875rem",
        "lineHeight": 1.2
      },
      "bold": {
        "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
        "fontWeight": 700,
        "fontSize": "0.875rem",
        "lineHeight": 1.2,
        "textTransform": "uppercase"
      },
      "subdued": {
        "fontFamily": "Futura PT, futura-pt, sans-serif",
        "fontWeight": 400,
        "fontSize": "0.75rem",
        "lineHeight": 1.2
      },
      "subduedBold": {
        "fontFamily": "Futura PT Bold, futura-pt-bold, sans-serif",
        "fontWeight": 700,
        "fontSize": "0.75rem",
        "lineHeight": 1.2
      },
      "semibold": {
        "fontFamily": "Futura PT, futura-pt, sans-serif",
        "fontWeight": 600,
        "fontSize": "1rem",
        "lineHeight": 1.2
      }
    },
    "textCase": {
      "upperCase": "uppercase",
      "titleCase": "capitalize"
    },
    "textDecoration": {
      "underline": "underline"
    }
  },
  "elevation": {
    "light": {
      "x": "0",
      "y": "0.25rem",
      "blur": "1rem",
      "spread": "0",
      "color": "rgba(0,0,0,0.12)",
      "type": "dropShadow"
    },
    "default": {
      "x": "0",
      "y": "1rem",
      "blur": "2rem",
      "spread": "0.25rem",
      "color": "rgba(0,0,0,0.05)",
      "type": "dropShadow"
    },
    "dark": {
      "x": "0",
      "y": "1rem",
      "blur": "1rem",
      "spread": "0",
      "color": "rgba(0,0,0,0.08)",
      "type": "dropShadow"
    },
    "headerNav": {
      "x": "0",
      "y": "1rem",
      "blur": "2rem",
      "spread": "0.25rem",
      "color": "rgba(0,0,0,0.12)",
      "type": "dropShadow"
    }
  },
  "size": {
    "0": "0rem",
    "100": "1rem",
    "125": "1.25rem",
    "150": "1.5rem",
    "175": "1.75rem",
    "200": "2rem",
    "225": "2.25rem",
    "250": "2.5rem",
    "300": "3rem",
    "350": "3.5rem",
    "400": "4rem",
    "500": "5rem",
    "600": "6rem",
    "800": "8rem",
    "006": "1rem",
    "012": "0.125rem",
    "025": "0.25rem",
    "050": "0.5rem",
    "075": "0.75rem",
    "087": "0.875rem"
  },
  "radius": {
    "button": {
      "default": "0px",
      "headerNav": "0px"
    }
  },
  "glass": {
    "default": {
      "backgroundBlur": "blur(31.9px)"
    }
  },
  "breakpoint": {
    "xs": {
      "min": "0px",
      "max": "767px"
    },
    "sm": {
      "min": "768px",
      "max": "1023px"
    },
    "md": {
      "min": "1024px",
      "max": "1199px"
    },
    "lg": {
      "min": "1200px",
      "max": "1439px"
    },
    "xl": {
      "min": "1440px"
    }
  }
}

export const space = tokens.space;
export const color = tokens.color;
export const font = tokens.font;
export const elevation = tokens.elevation;
export const size = tokens.size;
export const radius = tokens.radius;
export const glass = tokens.glass;
export const breakpoint = tokens.breakpoint;
export default tokens;
